(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/areas/toaster-area.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/areas/toaster-area.js'); "use strict";


(function (svs, gsap) {
  'use strict';

  svs = svs || {};
  svs.components = svs.components || {};
  svs.components.dialog = svs.components.dialog || {};

  class DialogToasterArea extends svs.components.dialog.PubSub {
    constructor(options) {
      super();
      this.log = new svs.core.log.Logger('DialogToasterArea');
      this.name = svs.components.dialog.area.TOASTER;
      this.items = [];
      this.el = options.el;
      this.options = options;
      this.render();
      this.init();
    }

    init() {
      const accessibilityOptions = {
        el: this.el,
        type: svs.components.dialog.area.TOASTER,
        activeElBeforeOpen: document.activeElement
      };
      this.accessibility = new svs.components.dialog.Accessibility(accessibilityOptions);
      window.addEventListener('resize', () => {
        const currentItem = this.items[0];

        if (currentItem) {
          this.setPositions();
        }
      });

      if (window.ResizeObserver !== undefined) {
        this.resizeObserver = new ResizeObserver(() => {
          this.updatePositions();
        });
      }
    }

    render() {
      this.el = document.createElement('div');
      this.el.className += 'js-dialog-items dialog-items dialog-toaster-items js-dialog-toaster-items focus-inverted';
      this.el.setAttribute('tabindex', '0');
      this.options.attachTo.appendChild(this.el);
    }

    remove() {
      this.options && this.options.attachTo && this.options.attachTo.removeChild(this.el);
      this.el = null;
      this.accessibility.removeListeners();
      this.emit('close');
    }

    add(dialog) {
      const popups = this.options.areas[svs.components.dialog.area.POPUP];

      if (!this.el) {
        this.render();
      }

      if (!popups || !popups.count() || popups && popups.count() === 1 && popups.items[0]._isClosing) {
        this.log.debug('Added to toasters');
        this.append(dialog);
        dialog.reveal();
        this.updatePositions();
        this.accessibility.focusElement(this.el);
      } else {
        this.log.debug('Added to popups');
        dialog.allowDimmerClick = false;
        popups.add(dialog);
      }
    }

    close(timing) {
      this.log.debug('No more dialogs here, close container', timing !== undefined ? timing : 0.2);
      const tweenVars = {
        height: 0,
        onComplete: () => {
          setTimeout(() => {
            this.remove();
          }, 100);
        }
      };

      if (timing === 0) {
        this.log.debug('Set height 0');
        gsap.set(this.el, tweenVars);
      } else {
        this.log.debug('Animate height 0');
        gsap.to(this.el, 0.2, tweenVars);
      }
    }

    append(dialog) {
      this.log.debug('Append dialog to be opened');
      dialog._queue = this;
      dialog.el.className += ' dialog-toaster-item';
      dialog.on('closed', this, () => {
        this.log.debug('A dialog was closed, now handle it.');
        this.unload(dialog);
      });
      this.items.push(dialog);
      this.el.appendChild(dialog.el);

      if (this.resizeObserver !== undefined) {
        this.resizeObserver.observe(dialog.el);
      }
    }

    setPositions() {
      this.log.debug('Set positions on toaster items');
      let totalHeight = 0;
      this.items.forEach(item => {
        gsap.set(item.el, {
          top: totalHeight
        });
        totalHeight += item.el.offsetHeight;
      });
      gsap.set(this.el, {
        height: totalHeight
      });
    }

    updatePositions() {
      this.log.debug('Update toaster items heights');
      let totalHeight = 0;
      this.items.forEach(item => {
        gsap.to(item.el, {
          duration: 0.2,
          top: totalHeight
        });
        totalHeight += item.el.offsetHeight;
      });
      gsap.to(this.el, {
        duration: 0.2,
        height: totalHeight
      });
    }

    unload(dialog) {
      this.items.forEach((item, i) => {
        if (item._id === dialog._id) {
          if (this.resizeObserver !== undefined) {
            this.resizeObserver.unobserve(item.el);
          }

          this.items.splice(i, 1);
          gsap.to(item.el, {
            duration: 0.2,
            height: 0,
            onComplete: () => {
              this.el && this.el.removeChild(item.el);
            }
          });
          item._rendered = false;
        }
      });

      if (!this.items.length) {
        this.log.debug('Set focus to element that was active before toaster was opened', this.accessibility.activeElBeforeOpen);
        this.accessibility.activeElBeforeOpen.focus();
        this.accessibility.removeListeners();

        if (this.resizeObserver !== undefined) {
          this.resizeObserver.disconnect();
        }

        this.close();
      } else {
        this.updatePositions();
      }
    }

    convertToPopups() {
      this.log.debug("Convert ".concat(this.items.length, " toasters -> popups"));
      const convertedItems = [];
      this.items.forEach(item => {
        if (item.options.convertToPopup) {
          this.el.removeChild(item.el);
          item.off('closed', this);
          item.options.autoClose = false;
          item.el.removeAttribute('style');
          item.options.area = svs.components.dialog.area.POPUP;
          item.el.classList.remove('dialog-toaster-item');
          convertedItems.push(item);
        } else {
          this.log.debug("Toaster with title ".concat(item.options.title || '[not set]', " not converted to popup"));
        }
      });
      this.items = [];
      this.close(0);
      return !convertedItems.length ? false : convertedItems;
    }

    status() {
      this.log.debug("".concat(this.name, " queue, ").concat(this.items.length, " still remain"));
    }

    count() {
      let c = 0;
      this.items.forEach(item => {
        if (!item.options.skipPopupQueue) {
          c++;
        }
      });
      return c;
    }

  } 


  svs.components.dialog.DialogToasterArea = DialogToasterArea;
  svs.components.dialog.area = svs.components.dialog.area || {};
  svs.components.dialog.area.TOASTER = 'toaster';
  svs.components.dialog.areas = svs.components.dialog.areas || {};
  svs.components.dialog.areas[svs.components.dialog.area.TOASTER] = svs.components.dialog.DialogToasterArea;
})(svs, gsap);
 })(window);